export default __webpack_public_path__ + "static/media/mt4.a5c48ee2.png";